import { LayoutDashboard, Pill, BarChart3, Settings } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Sidebar() {
  return (
    <div className="w-64 bg-white border-r h-screen p-6">
      <h1 className="text-xl font-bold mb-8">Medicine Admin</h1>

      <nav className="space-y-4">
        <Link
          to="/admin/dashboard"
          className="flex items-center gap-3 text-gray-700 hover:text-indigo-600 cursor-pointer"
        >
          <LayoutDashboard size={18} />
          Dashboard
        </Link>

        <Link
          to="/admin/medicines"
          className="flex items-center gap-3 text-gray-700 hover:text-indigo-600 cursor-pointer"
        >
          <Pill size={18} />
          Medicines
        </Link>

        <Link
          to="/admin/analytics"
          className="flex items-center gap-3 text-gray-700 hover:text-indigo-600 cursor-pointer"
        >
          <BarChart3 size={18} />
          Analytics
        </Link>

        <Link
          to="/admin/settings"
          className="flex items-center gap-3 text-gray-700 hover:text-indigo-600 cursor-pointer"
        >
          <Settings size={18} />
          Settings
        </Link>
      </nav>
    </div>
  );
}
